import React, { useContext } from "react";

import { MegaphoneIcon } from "@heroicons/react/24/outline";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import Modal from "@/common/Modal";
import constants from "@/utils/constants";

import { AccountContext } from "../Account/Account";
import ConfigContext from "../Config/configContext";
import { OutletsContext } from "../Outlets";
import ChimeBell from "./audio/chimebell.mp3";
import Consequence from "./audio/consequence.mp3";

export const AudioEnabledContext = React.createContext({});
export const AudioEnabledProvider = AudioEnabledContext.Provider;

EnableAudioModal.propTypes = {
  audioEnabled: PropTypes.bool,
  setAudioEnabled: PropTypes.func,
  audioRef: PropTypes.object,
  chimeRef: PropTypes.object,
};

function EnableAudioModal({
  audioEnabled,
  setAudioEnabled,
  audioRef,
  chimeRef,
}) {
  const { t } = useTranslation();

  const { configLoading, brandConfigsLoading, merchantAppLoading } =
    useContext(ConfigContext);
  const { accountLoading } = useContext(AccountContext);
  const { outletsLoading } = useContext(OutletsContext);

  if (
    configLoading ||
    brandConfigsLoading ||
    merchantAppLoading ||
    accountLoading ||
    outletsLoading
  ) {
    return null;
  }

  return (
    <>
      <audio ref={audioRef} id="incoming-alert-audio">
        <source src={Consequence} type="audio/mpeg"></source>
      </audio>
      <audio ref={chimeRef} id="chime-audio">
        <source src={ChimeBell} type="audio/mpeg"></source>
      </audio>
      <Modal
        zIndex={9999}
        visible={
          !audioEnabled &&
          window.location.pathname !== constants.CUSTOMER_FACING_DISPLAY_PATH
        }
        maskClosable={true}
        closable={true}
        layout="vertical"
        icon={
          <div className="flex items-center justify-center mx-auto mb-4 bg-green-100 rounded-full h-14 w-14">
            <div className="p-4">
              <MegaphoneIcon className="w-6 h-6 text-green-600" />
            </div>
          </div>
        }
        okText={t("enableAudioModal.acknowledge")}
        title={t("enableAudioModal.title")}
        onCancel={() => setAudioEnabled(true)}
        hasCancelButton={false}
        onOk={() => {
          if (audioRef.current) audioRef.current.muted = false;
          setAudioEnabled(true);
        }}
      />
    </>
  );
}

export default EnableAudioModal;
